import { useEffect } from "react";
import "./style.sass";
import assets from "../../assets";

const DEFAULT_DEEP_LINK = "rovianapp://payment_success";

export const Success = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    const targetUrl =
      params.get("callback") || params.get("redirect") || DEFAULT_DEEP_LINK;

    // Auto redirect after 1.5 seconds
    const redirectTimer = setTimeout(() => {
      window.location.href = targetUrl;
    }, 1500);

    // Confetti animation
    const triggerConfetti = () => {
      const colors = [
        "#6C3EE8",
        "#8B63FF",
        "#10B981",
        "#FFB020",
        "#3B82F6",
        "#EC4899",
        "#F43F5E",
      ];

      const mascotElement = document.querySelector(".payment-success__mascot");

      if (!mascotElement) return;

      const rect = mascotElement.getBoundingClientRect();

      const centerX = rect.left + rect.width / 2 + window.scrollX;
      const centerY = rect.top + rect.height / 2 + window.scrollY;

      for (let i = 0; i < 55; i++) {
        const particle = document.createElement("div");

        particle.className = "particle";

        particle.style.borderRadius = Math.random() > 0.4 ? "50%" : "2px";

        const size = 6 + Math.random() * 8;

        particle.style.width = `${size}px`;
        particle.style.height = `${size}px`;

        particle.style.backgroundColor =
          colors[Math.floor(Math.random() * colors.length)];

        particle.style.left = `${centerX}px`;
        particle.style.top = `${centerY}px`;

        const angle = Math.random() * Math.PI * 2;
        const distance = 40 + Math.random() * 120;

        particle.style.setProperty("--x", `${Math.cos(angle) * distance}px`);

        particle.style.setProperty(
          "--y",
          `${Math.sin(angle) * distance - 20}px`,
        );

        particle.style.setProperty("--scale", 0.4 + Math.random() * 0.8);

        particle.style.setProperty("--rotate", `${Math.random() * 360}deg`);

        particle.style.setProperty(
          "--duration",
          `${0.6 + Math.random() * 0.7}s`,
        );

        document.body.appendChild(particle);

        setTimeout(() => particle.remove(), 1500);
      }
    };

    const confettiTimer = setTimeout(triggerConfetti, 250);

    return () => {
      clearTimeout(redirectTimer);
      clearTimeout(confettiTimer);

      document.querySelectorAll(".particle").forEach((el) => el.remove());
    };
  }, []);

  const params = new URLSearchParams(window.location.search);

  const targetUrl =
    params.get("callback") || params.get("redirect") || DEFAULT_DEEP_LINK;

  return (
    <section className="payment-success">
      <section className="payment-success__card">
        <img
          src={assets.img_khan_academy_logo}
          alt="Logo"
          className="payment-success__logo"
        />

        <section className="payment-success__mascot">
          <section className="payment-success__glow" />

          <img
            src={assets.img_robot}
            alt="Mascot"
            className="payment-success__image"
          />
        </section>

        <h1 className="payment-success__title">Payment Successful</h1>

        <p className="payment-success__highlight">
          Please return to the app to continue.
        </p>

        <a href={targetUrl} className="payment-success__link">
          <span>Return to App</span>

          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="5" y1="12" x2="19" y2="12" />
            <polyline points="12 5 19 12 12 19" />
          </svg>
        </a>
      </section>
    </section>
  );
};
